import { render } from "./ModalContato.vue?vue&type=template&id=6edc1d69&scoped=true"
import script from "./ModalContato.vue?vue&type=script&lang=js"
export * from "./ModalContato.vue?vue&type=script&lang=js"

import "./ModalContato.vue?vue&type=style&index=0&id=6edc1d69&scoped=true&lang=css"

import exportComponent from "/var/www/html/lr-courses/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6edc1d69"]])

export default __exports__